let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b15v2")).then(() => parcelRequire('5w7vf'));